import script from "./CourseOutlinesView.vue?vue&type=script&setup=true&lang=js"
export * from "./CourseOutlinesView.vue?vue&type=script&setup=true&lang=js"

import "./CourseOutlinesView.vue?vue&type=style&index=0&id=a72b6c04&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a72b6c04"]])

export default __exports__